<template>
    <div class="wrapper">
        <div class="header" v-if="property.back === 'true' || property.back === true">
            <div class="button-area" @click="back">
                <img class="back" src="../../assets/left_pointing_arrow.png" />
            </div>
            <span>개인정보 제3자 제공 동의서 (엥자이랙스)</span>
        </div>
        <div v-if="policies !== null" style="margin-top: 30px;">
            <span class="title">변경 이력</span>
            <div class="list">
                <div v-for="(policy, index) in policies">
                    <span class="label">{{convertTimestamp(policy.revisionDate)}} 개정</span> <span class="link" v-if="selected != index" @click="selectRevision(index)">- 확인하러 가기</span>
                </div>
            </div>
        </div>
        <div v-if="curPolicy != null" style="margin-top: 50px" v-html="curPolicy.content">
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';
import {mapState} from 'vuex';

export default {
    name: 'anzeilaxThirdParty',
    computed: mapState(['property']),
    data: function()
    {
        return {
            content: null,
            curPolicy: null,
            selected: -1,
            policies: null
        }
    },
    mounted: function()
    {         
        this.$store.dispatch(Constant.FETCH_CATEGORIES)
            .then((res) => {
                this.content = res
                for(var i = 0; i < this.content.length; i++)
                {
                    if(this.content[i].id === 9)
                    {
                        this.policies = this.content[i].policies;
                        this.selected = 0;
                    }
                }
            })
            .catch(() => {

            })
        
    },
    methods: {
        selectRevision: function(index)
        {
            this.selected = index;
        },
        convertTimestamp: function(stamp)
        {
            
            var date = new Date(stamp);
            var month = date.getMonth() + 1;
            var text = '오전';
            var hour = date.getHours();
            if(date.getHours() >= 12)
            {
                text = '오후'

                if(hour != 12)
                {
                    hour = hour - 12;
                }
            }

            return date.getFullYear() + "년 " + this.leadingZeros(month, 2) + "월 " + this.leadingZeros(date.getDate(), 2) + "일 ";
        },
        leadingZeros: function(n, digits) {
            var zero = '';
            n = n.toString();
            if (n.length < digits) {
                for (var i = 0; i < digits - n.length; i++)
                    zero += 0;
            }
            return zero + n;
        },
        back: function()
        {
            this.$router.push({path: '/'})
        }
    },
    watch: {
        selected: function()
        {
             this.$store.dispatch(Constant.FETCH_POLICY, {policyId: this.policies[this.selected].id})
                .then((res) => {
                    this.curPolicy = res;
                })
        },
        'property.padding': function()
        {
            const el = document.querySelector('.wrapper');
            el.style.padding = `${this.property.padding}px`;
        }
    }
}
</script>

<style scoped>
    .title {
        font-size: 18px;
    }
    .label {
        font-size: 15px;
        color: gray;
    }
    .list {
        display: flex;
        flex-direction: column;
        gap: 3px;
        margin-top: 10px;
    }
    .link {
        text-decoration: underline;
        cursor: pointer;
        color: blue;
        font-size: 15px;
    }
    .header{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        font-weight: 500;
        height: 35px;
    }
    .back {
        width: 22px;
    }
    .button-area {
        position: absolute;
        left: 0;
        width: 35px;
        height: 35px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/pages/anzeilax/ThirdParty.vue